import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { map } from 'rxjs/operators';

const routes = {
  path: '/users/user-enterprise/search',
  feature: (enterpriseId: any) => `/users/group-user/find-by-enterprise/${enterpriseId}`,
  permission: '/permissions/user/grant-permission',
  delete: (id: number) => `/employees/${id}`,
  addUserEnterprise: '/users/user-enterprise',
  getUserById: (id: any) => `/users/user-detail/${id}`,
  getEnterpriseAccount: (enterpriseId: string) => `/enterprises/admin-name/${enterpriseId}`,
  update: (id: string) => `/users/user-enterprise/${id}`,
  updatePer: (id: string) => `/users/user-enterprise-per/${id}`,
  changeStatus: (id: string) => `/users/user-change-status/${id}`,
  findChild: (id: number) => `/enterprises/child/${id}`,
  changePassword: () => "/users/change-password",
  changePasswordFirstTime: () => "/users/change-password-first-login",
  removeUser: () => '/users/user-enterprise/remove-user',
  me: () => "/users/me",
  mysignSessionConfiguration: `/user-config/transaction-mysign`,
};

const GET_IMPORT_LOT_BY_ID = '/import-lot/get-by-id/';
const GET_ALL_PROCESSING = '/import-lot/get-all-processing';
const CREATE_IMPORT_LOT = '/import-lot/create';
const GET_RESULT_FILE = '/import-lot/get-result-file/'

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private apiService: ApiService) { }

  addUserEnterprise(user: any, errCallback?: any) {
    return this.apiService.post(routes.addUserEnterprise, user).pipe(
      map(res => {
        if (errCallback && !res.success) errCallback(res);
        return res;
      })
    );
  }

  updateUserEnterprise(userId: string, value: any, callBack: any, noCallBack: any, errCallback?: any) {
    return this.apiService.putAndCheckVersion(routes.update(userId), value, callBack, noCallBack, errCallback);
  }

  updateUserPerEnterprise(userId: string, value: any) {
    return this.apiService.post(routes.updatePer(userId), value);
  }

  /**
   * Get user groups
   */
  getFeatureList(enterpriseId: string) {
    return this.apiService.get(routes.feature(enterpriseId)).pipe();
  }

  grantPermmision(request: any) {
    return this.apiService.post(routes.permission, request).pipe();
  }

  getAllChild(id: any) {
    return this.apiService.get(routes.findChild(id)).pipe();
  }

  getAll(filter: any) {
    return this.apiService.postSilently(routes.path, filter).pipe();
  }

  changeStatus(id: string) {
    return this.apiService.get(routes.changeStatus(id));
  }

  /**
   * Get user by id
   */
  getUser(userId: any) {
    return this.apiService.get(routes.getUserById(userId)).pipe();
  }

  /**
   * Get account of the enterprise which current user is belong to
   * @param enterpriseId: string
   */
  getEnterpriseAccount(enterpriseId: string) {
    return this.apiService.get(routes.getEnterpriseAccount(enterpriseId)).pipe();
  }



  /**
   * <pre>
   * <b>Method name: changePassword</b>
   * <b>Explanation: </b> Method change password
   * </pre>
   * @author GCS 2019/12/09 by thanghl
   *
   */
  changePassword(passwordData: any) {
    return this.apiService.post(routes.changePassword(), passwordData).pipe();
  }

  changePasswordFirstTime(passwordData: any) {
    return this.apiService.post(routes.changePasswordFirstTime(), passwordData).pipe();
  }

  getImportLotById(id) {
    return this.apiService.get(GET_IMPORT_LOT_BY_ID + id)
      .pipe(map(res => {
        return res
      }));
  }

  getAllProcessing(param: { page: number, size: number }) {
    return this.apiService.get(`${GET_ALL_PROCESSING}?page=${param.page}&size=${param.size}`)
      .pipe(map(res => {
        return res
      }));
  }

  createContractLot(body) {
    return this.apiService.post(CREATE_IMPORT_LOT, body)
      .pipe(map(res => {
        return res
      }));
  }

  getResultFile(id: string) {
    return this.apiService.getFilePostMethod(`${GET_RESULT_FILE}${id}`, null)
      .pipe(map(res => {
        return res;
      }))
  }
  me() {
    return this.apiService.get(routes.me()).pipe(map(res => {
      return res;
    }))
  }

  removeUser(userId: any) {
    return this.apiService.post(routes.removeUser(), userId)
      .pipe(map(res => {
        return res;
      }));
  }
  saveMysignSessionConfiguration(body: any) {
    return this.apiService.post(routes.mysignSessionConfiguration, body).pipe();
  }

  getMysignSessionConfiguration() {
    return this.apiService.get(routes.mysignSessionConfiguration).pipe(map(res => {
      return res
    }));
  }
}
